import store from '/chat/src/redux/store';
import langauge from '/chat/src/languages/lang';

var MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
var WEEK_DAY = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

class DateTime {
    constructor(){
        var selected = store.getState().getIn(['customization', 'default_language'], 'se')
        this.language = langauge[selected]
    }
    
    formatDate(dateString, format) {
        const date = this.getUTCDate(dateString);

        switch (format) {
            case 'hh:mm':
                return this.getTime(date);
            case 'yyyy-mm-dd':
                return this.getDate(date);
            case 'yyyy-mm-dd hh:mm':
                return `${this.getDate(date)} ${this.getTime(date)}`;
            default:
                return `${this.getDate(date)} ${this.getTime(date)}`;
        }
    }

    getUTCDate(dateString) {
        // replace - with / in dateString for browser compatibility.
        dateString = dateString.replace(/-/g, "/");

        // Entries that come via socket have a date then a dot followed by a 6 digit number that should not be in the date
        dateString = dateString.split('.')[0];

        /*
        * The date we get from the server is UTC time.
        * We need to add UTC to the end of date_created
        * so that the Date function will convert it to
        * the UTC time that the browser is using.
        */
        const dateStringUTC = dateString;

        return new Date(dateStringUTC);
    }

    getTimestamp(dateString) {
        return this.getUTCDate(dateString).getTime();
    }

    getTime(date) {
        const hours = this.padDate(date.getHours());
        const minutes = this.padDate(date.getMinutes());
        return `${hours}:${minutes}`;
    }

    getDate(date) {
        const year = date.getFullYear();
        const month = this.padDate(date.getMonth() + 1);
        const day = this.padDate(date.getDate());
        return `${year}-${month}-${day}`;
    }

    padDate(number) {
        number = String(number);
        if (number.length === 1) {
            number = `0${number}`;
        }
        return number;
    }

    isToday(dateString) {
        const date = this.getUTCDate(dateString);
        const today = new Date();
        return today.toDateString() === date.toDateString();
    }

    getDiffTime(here, there){
        let hereDate = this.getUTCDate(here);
        let thereDate = this.getUTCDate(there);
        return Math.abs(hereDate - thereDate);
    }
    getDiffMinutes(here, there){
        return Math.ceil(this.getDiffTime(here,there)/(1000*60));
    }

    getDetailedNiceDate(dateString) {

        const date = this.getUTCDate(dateString);
        const today = new Date()

        if (this.isToday(dateString)) return `${this.language["Today"]} ${this.getTime(date)}`
        
        const weekDate = date.getDay()
        const monthDate = date.getMonth()
        let weekKey = WEEK_DAY[weekDate]
        let week = this.language[weekKey].substring(0,3)
        let monthKey = MONTH_NAMES[monthDate]
        let month = this.language[monthKey].substring(0,3)


        var timeDiff = Math.abs(today.getTime() - date.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if (diffDays === 1)
            return `${this.language["Yesterday"]} ` + this.getTime(date);
        if (diffDays < 7)
            return `${week} ${this.getTime(date)}`;
        return `${date.getDate()} ${month} ${this.getTime(date)}`;
    }
}

export default new DateTime();



// WEBPACK FOOTER //
// ./lib/DateTime.js